import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { fetchSupplierParameters } from "../../core/actions"
import {
  getSupplierParameters,
  getTranslationsByScope,
} from "../../core/reducers"
import Home from "../views/viw_home"

const mapStateToProps = (state: any) => ({
  supplierParameters: getSupplierParameters(state),
  translations: getTranslationsByScope(state, "home"),
})

const mapDispatchToProps = {
  fetchSupplierParameters,
}

export default withRouter<any & any>(
  connect(mapStateToProps, mapDispatchToProps)(Home)
)
